export type AtVirtualClinicTissAAtemwegszugang =
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5';

export const AT_VIRTUAL_CLINIC_TISS_A_ATEMWEGSZUGANG_DISPLAY_NAMES: {
  [status in AtVirtualClinicTissAAtemwegszugang]: string;
} = {
  '0': 'Keine Atemwegszugang/nicht erhoben',
  '1': 'O₂-Maske oder-Brille',
  '2': 'CPAP-Maske',
  '3': 'CPAP-Helm',
  '4': 'Tubus',
  '5': 'Kanüle',
};
